import { Component } from '@angular/core';

@Component({
  selector: 'app-fcir25',
  templateUrl: './fcir25.component.html',
  styleUrl: './fcir25.component.css'
})
export class Fcir25Component {

}
